<div class="cdk-virtual-scroll-data-source-example">
<cdk-virtual-scroll-viewport appendOnly  orientation="horizontal" [itemSize]="50" class="example-viewport" *ngIf="type=='Assessment'">
<!--  <mat-horizontal-stepper [linear]="true">-->
<!--    <mat-step *ngFor="let chartData of chartOptions">-->
      <div *cdkVirtualFor="let data of mAssessments"  class="example-item" >

              <div class="header">
                <h5 class="text-center">
                {{data.type}} <br>{{data?.dateOfAssessment?.toDate()|date:'dd-MM-yyyy'}} </h5>
              </div>
              <div class="body">
                <canvas baseChart
                        [labels]="doughnutChartLabels"
                        [datasets]="calculateGraphData(data)"
                        [options]="doughnutChartOptions"
                        [legend]="true"
                        [type]="'doughnut'" >

                </canvas>&nbsp;
              </div>
      </div>
<!--    </mat-step>-->
<!--  </mat-horizontal-stepper>-->
</cdk-virtual-scroll-viewport>

  <cdk-virtual-scroll-viewport appendOnly  orientation="horizontal" [itemSize]="50" class="example-viewport" *ngIf="type=='FollowUp'">
    <!--  <mat-horizontal-stepper [linear]="true">-->
    <!--    <mat-step *ngFor="let chartData of chartOptions">-->
    <div *cdkVirtualFor="let data of mAssessments"  class="example-item" >

      <div class="header">
        <h5 class="text-center">
          {{data.type}} <br>{{data?.dateOfAssessment?.toDate()|date:'dd-MM-yyyy'}} </h5>
      </div>
      <div class="body">
        <canvas baseChart
                [labels]="doughnutChartLabels"
                [datasets]="calculateFGraphData(data)"
                [options]="doughnutChartOptions"
                [legend]="true"
                [type]="'doughnut'" >

        </canvas>&nbsp;
      </div>
    </div>
    <!--    </mat-step>-->
    <!--  </mat-horizontal-stepper>-->
  </cdk-virtual-scroll-viewport>

</div>
